// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"5e12a091","628":"0ad29220","904":"c0a58ccc","991":"56be46f1"}[chunkId] + ".chunk.css";
};